import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { TxKeyword, ScSelection } from '../_models';
import { BaseResponse, ListResponse,ArrayResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TxKeywordService {
    constructor(private http: HttpClient) { }

    getKeyword(id: any): Observable<TxKeyword> { //detail
      return this.http.get(`${environment.apiUrl}/tx/keyword/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new TxKeyword().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/tx/keyword/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, TxKeyword);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addKeyword(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/tx/keyword/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateKeyword(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/tx/keyword/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteKeyword(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/tx/keyword/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getSelectionSources(): Observable<any> {
      return this.http.get(`${environment.apiUrl}/tx/keyword/selection/source`)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getSelectionScAndKws(sourceId, country): Observable<any> {
      return this.http.get(`${environment.apiUrl}/tx/keyword/selection/sc-kws?source=${sourceId}&country=${country}`)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    allShortCodeForSelection(): Observable<ArrayResponse>{
      return this.http.get(`${environment.apiUrl}/tx/keyword/selection/sc-all`)
      .pipe(
        map((data: any) => {
          if(data && data.status && data.status == 1 && data.data){
             return new ArrayResponse().deserialize(data, ScSelection);
          }else{
             return null;
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

}
